import { SelectDataType } from '~/components/EFSelect/EFSelect.model'

export const LOCALES_SELECT = [
  { name: 'English (American Samoa)', value: 'en-AS' },
  { name: 'English (Anguilla)', value: 'en-AI' },
  { name: 'English (Antigua and Barbuda)', value: 'en-AG' },
  { name: 'English (Australia)', value: 'en-AU' },
  { name: 'English (Austria)', value: 'en-AT' },
  { name: 'English (Bahamas)', value: 'en-BS' },
  { name: 'English (Barbados)', value: 'en-BB' },
  { name: 'English (Belgium)', value: 'en-BE' },
  { name: 'English (Belize)', value: 'en-BZ' },
  { name: 'English (Bermuda)', value: 'en-BM' },
  { name: 'English (Botswana)', value: 'en-BW' },
  { name: 'English (British Indian Ocean Territory)', value: 'en-IO' },
  { name: 'English (British Virgin Islands)', value: 'en-VG' },
  { name: 'English (Burundi)', value: 'en-BI' },
  { name: 'English (Cameroon)', value: 'en-CM' },
  { name: 'English (Canada)', value: 'en-CA' },
  { name: 'English (Caribbean)', value: 'en-029' },
  { name: 'English (Cayman Islands)', value: 'en-KY' },
  { name: 'English (Christmas Island)', value: 'en-CX' },
  { name: 'English (Cocos (Keeling) Islands)', value: 'en-CC' },
  { name: 'English (Cook Islands)', value: 'en-CK' },
  { name: 'English (Cyprus)', value: 'en-CY' },
  { name: 'English (Denmark)', value: 'en-DK' },
  { name: 'English (Dominica)', value: 'en-DM' },
  { name: 'English (Eritrea)', value: 'en-ER' },
  { name: 'English (Europe)', value: 'en-150' },
  { name: 'English (Falkland Islands)', value: 'en-FK' },
  { name: 'English (Fiji)', value: 'en-FJ' },
  { name: 'English (Finland)', value: 'en-FI' },
  { name: 'English (Gambia)', value: 'en-GM' },
  { name: 'English (Germany)', value: 'en-DE' },
  { name: 'English (Ghana)', value: 'en-GH' },
  { name: 'English (Gibraltar)', value: 'en-GI' },
  { name: 'English (Grenada)', value: 'en-GD' },
  { name: 'English (Guam)', value: 'en-GU' },
  { name: 'English (Guernsey)', value: 'en-GG' },
  { name: 'English (Guyana)', value: 'en-GY' },
  { name: 'English (Hong Kong SAR)', value: 'en-HK' },
  { name: 'English (India)', value: 'en-IN' },
  { name: 'English (Indonesia)', value: 'en-ID' },
  { name: 'English (Ireland)', value: 'en-IE' },
  { name: 'English (Isle of Man)', value: 'en-IM' },
  { name: 'English (Israel)', value: 'en-IL' },
  { name: 'English (Jamaica)', value: 'en-JM' },
  { name: 'English (Jersey)', value: 'en-JE' },
  { name: 'English (Kenya)', value: 'en-KE' },
  { name: 'English (Kiribati)', value: 'en-KI' },
  { name: 'English (Lesotho)', value: 'en-LS' },
  { name: 'English (Liberia)', value: 'en-LR' },
  { name: 'English (Macao SAR)', value: 'en-MO' },
  { name: 'English (Madagascar)', value: 'en-MG' },
  { name: 'English (Malawi)', value: 'en-MW' },
  { name: 'English (Malaysia)', value: 'en-MY' },
  { name: 'English (Malta)', value: 'en-MT' },
  { name: 'English (Marshall Islands)', value: 'en-MH' },
  { name: 'English (Mauritius)', value: 'en-MU' },
  { name: 'English (Micronesia)', value: 'en-FM' },
  { name: 'English (Montserrat)', value: 'en-MS' },
  { name: 'English (Namibia)', value: 'en-NA' },
  { name: 'English (Nauru)', value: 'en-NR' },
  { name: 'English (Netherlands)', value: 'en-NL' },
  { name: 'English (New Zealand)', value: 'en-NZ' },
  { name: 'English (Nigeria)', value: 'en-NG' },
  { name: 'English (Niue)', value: 'en-NU' },
  { name: 'English (Norfolk Island)', value: 'en-NF' },
  { name: 'English (Northern Mariana Islands)', value: 'en-MP' },
  { name: 'English (Pakistan)', value: 'en-PK' },
  { name: 'English (Palau)', value: 'en-PW' },
  { name: 'English (Papua New Guinea)', value: 'en-PG' },
  { name: 'English (Philippines)', value: 'en-PH' },
  { name: 'English (Pitcairn Islands)', value: 'en-PN' },
  { name: 'English (Puerto Rico)', value: 'en-PR' },
  { name: 'English (Rwanda)', value: 'en-RW' },
  { name: 'English (Saint Kitts and Nevis)', value: 'en-KN' },
  { name: 'English (Saint Lucia)', value: 'en-LC' },
  { name: 'English (Saint Vincent and the Grenadines)', value: 'en-VC' },
  { name: 'English (Samoa)', value: 'en-WS' },
  { name: 'English (Seychelles)', value: 'en-SC' },
  { name: 'English (Sierra Leone)', value: 'en-SL' },
  { name: 'English (Singapore)', value: 'en-SG' },
  { name: 'English (Sint Maarten)', value: 'en-SX' },
  { name: 'English (Slovenia)', value: 'en-SI' },
  { name: 'English (Solomon Islands)', value: 'en-SB' },
  { name: 'English (South Africa)', value: 'en-ZA' },
  { name: 'English (South Sudan)', value: 'en-SS' },
  { name: 'English (St Helena, Ascension, Tristan da Cunha)', value: 'en-SH' },
  { name: 'English (Sudan)', value: 'en-SD' },
  { name: 'English (Swaziland)', value: 'en-SZ' },
  { name: 'English (Sweden)', value: 'en-SE' },
  { name: 'English (Switzerland)', value: 'en-CH' },
  { name: 'English (Tanzania)', value: 'en-TZ' },
  { name: 'English (Tokelau)', value: 'en-TK' },
  { name: 'English (Tonga)', value: 'en-TO' },
  { name: 'English (Trinidad and Tobago)', value: 'en-TT' },
  { name: 'English (Turks and Caicos Islands)', value: 'en-TC' },
  { name: 'English (Tuvalu)', value: 'en-TV' },
  { name: 'English (U.S. Outlying Islands)', value: 'en-UM' },
  { name: 'English (U.S. Virgin Islands)', value: 'en-VI' },
  { name: 'English (Uganda)', value: 'en-UG' },
  { name: 'English (United Kingdom)', value: 'en-GB' },
  { name: 'English (United States)', value: 'en-US' },
  { name: 'English (Vanuatu)', value: 'en-VU' },
  { name: 'English (World)', value: 'en-001' },
  { name: 'English (Zambia)', value: 'en-ZM' },
  { name: 'English (Zimbabwe)', value: 'en-ZW' }
] as SelectDataType[]

export const OTAP_AGENT_UPLOAD_INTERVAL = [
  { name: '1', value: 1 },
  { name: '2', value: 2 },
  { name: '3', value: 3 },
  { name: '4', value: 4 },
  { name: '5', value: 5 },
  { name: '6', value: 6 },
  { name: '7', value: 7 },
  { name: '8', value: 8 },
  { name: '9', value: 9 },
  { name: '10', value: 10 },
  { name: '11', value: 11 },
  { name: '12', value: 12 },
  { name: '13', value: 13 },
  { name: '14', value: 14 },
  { name: '15', value: 15 },
  { name: '16', value: 16 },
  { name: '17', value: 17 },
  { name: '18', value: 18 },
  { name: '19', value: 19 },
  { name: '20', value: 20 },
  { name: '21', value: 21 },
  { name: '22', value: 22 },
  { name: '23', value: 23 },
  { name: '24', value: 24 }
] as SelectDataType[]
